import { Auth as AuthClass } from './Auth';

const Auth: AuthClass = new AuthClass();
export default Auth;
export { Auth };
export * from './types';
export * from './AuthError';
